import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function VideoEffectsDemoPage() {
  const navigate = useNavigate();
  const [index, setIndex] = useState(0);

  const effects = [
    { emoji: "😎", color: "#00f2ff", label: "Glow futuriste" },
    { emoji: "🤖", color: "#ff00ff", label: "Mode robot IA" },
    { emoji: "🥶", color: "#00aaff", label: "Effet froid" },
    { emoji: "😈", color: "#ff0033", label: "Ambiance dark" },
  ];

  // 🔥 animation auto
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((i) => (i + 1) % effects.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "#03070d",
        color: "#fff",
      }}
    >
      {/* 🔙 RETOUR */}
      <button
        onClick={() => navigate(-1)}
        style={{
          position: "absolute",
          top: 20,
          left: 20,
          border: "1px solid #00f2ff",
          background: "transparent",
          color: "#00f2ff",
          padding: "10px 14px",
          borderRadius: 10,
        }}
      >
        ← Retour
      </button>

      {/* CONTENU */}
      <div
        style={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h1 style={{ marginBottom: 10 }}>✨ Effets modernes</h1>

        <p style={{ color: "#9befff", marginBottom: 30 }}>
          Transformations visuelles en temps réel
        </p>

        {/* 📱 FAKE VIDEO */}
        <div
          style={{
            width: 320,
            height: 580,
            borderRadius: 30,
            overflow: "hidden",
            border: `2px solid ${effects[index].color}`,
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "#000",
          }}
        >
          {/* 🎨 GLOW BACKGROUND */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              background: effects[index].color,
              opacity: 0.15,
              transition: "0.5s",
            }}
          />

          {/* 😈 EMOJI ANIMÉ */}
          <div
            style={{
              fontSize: 90,
              animation: "zoom 1.5s ease-in-out",
              filter: `drop-shadow(0 0 25px ${effects[index].color})`,
              transition: "0.5s",
            }}
          >
            {effects[index].emoji}
          </div>

          {/* LABEL */}
          <div
            style={{
              position: "absolute",
              bottom: 20,
              color: effects[index].color,
              fontWeight: "bold",
            }}
          >
            {effects[index].label}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes zoom {
          0% { transform: scale(0.6) rotate(-10deg); opacity: 0; }
          50% { transform: scale(1.2) rotate(5deg); opacity: 1; }
          100% { transform: scale(1) rotate(0deg); }
        }
      `}</style>
    </div>
  );
}

export default VideoEffectsDemoPage;